import { ACTIVATION_USER } from "../../../api/apiRoutes";
import useApiRequest from "../../../../utils/hooks/useApiRequest";

export default function useActivationUser() {
  const { get } = useApiRequest();
  const activateUser = async (token: string, ids: string) => {
    await get(ACTIVATION_USER(token, ids));
  };

  return {
    activateUser,
  };
}
